module.exports = "<ng-container steel-profile-form></ng-container>"


//////////////////
// WEBPACK FOOTER
// ./src/app/steel-profile/steel-profile-forms/steel-profile-form-selector/steel-profile-form-selector.component.html
// module id = 804
// module chunks = 0